export enum ImageWidth {
  AUTO = 'AUTO',
  FULL_WIDTH = 'FULL_WIDTH',
}
